import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import ServiceApi from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { changeLang } from "../../../../actions/langAction";
import { setDynamic } from "../../../../actions/dynamicAction";
/* component */
import Layout from "../../../../components/layout_operation";
import {
  Header,
  Mainjobtype,
  Problemdetail,
  Employment,
  Startstation,
  Stopstation,
  Effectsite,
} from "../../../../components/uih/addjob";
import Jobdetail from "../../../../components/uih/editjob/jobdetail/JobDetaiEdit";
import { notification, Spin, Modal, Radio, Select } from "antd";
import moment from "moment";
import { Helmet } from "react-helmet";
import { async } from "q";
import { LoadingOutlined } from "@ant-design/icons";

function Editjob(props) {
  const {
    company_id: CompanyId,
    operator_id: OperatorId,
    project_id: ProjectId,
    job_id,
  } = useParams();
  /* state */
  const [FormData, setFormData] = useState({
    job_type_id: "",
    job_sub_type_id: "",
    soid: "",
    saptype: "",
    workcenter: "",
    subcenter: "",
    alarmtype: "",
    alarmdata: "",
    startdate: new Date(),
    madate: "",
    informby: Cookies.get("username"),
    jobdetail: "",
    remark: "",
    slalevel: "",
    sla_time_day: "",
    sla_time_hour: "",
    sla_time_min: "",
    priority: "",
    employment: "",
    employmenttype: "",
    employmentreson: "",
    startsiteid: "",
    startsitegrade: "",
    startsitename: "",
    startsitelatitude: "",
    startsitelongtitude: "",
    stopsiteid: "",
    stopsitegrade: "",
    stopsitename: "",
    stoptsitelatitude: "",
    stoptsitelongtitude: "",
    numofeffectsite: "",
    effectsiteid: "",
    IsHold: false,
  });
  const [areacode, setareacode] = useState("");
  const { factUpdate, LangTranslate } = props;
  // const [factUpdate, setfactUpdate] = useState(false);
  // const [LangTranslate, setLangTranslate] = useState([]);
  const locale = Cookies.get("locale");
  const [JobCategory, setJobCategory] = useState(1);
  const [JobTypeId, setJobTypeId] = useState(null);
  const [JobCatSelect, setJobCatSelect] = useState([]);
  const [Sla, setSla] = useState([]);
  const [Slatime, setSlatime] = useState({
    sla_time_day: "",
    sla_time_hour: "",
    sla_time_min: "",
  });
  const [submitStatus, setsubmitStatus] = useState(false);
  const [Spinnig, setSpinnig] = useState(true);
  const [workflowJob, setworkflowJob] = useState([]);
  const [modalDisplay, setModalDisplay] = useState(false);
  const [valueTextFilter, setValueTextFilter] = useState("");
  const [workCenterID, setWorkCenterID] = useState("");
  const [checkReopen, setCheckReopen] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [dataLoad, setDataLoad] = useState([]);

  const [valueRadio, setValueRadio] = useState(true);

  const [selectJobType, setSelectJobType] = useState([]);
  const [selectJobSubType, setSelectJobSubType] = useState([]);
  const [selectAssignedGroup, setSelectAssignedGroup] = useState([]);

  const [valueJobType, setValueJobType] = useState(null);
  const [valueJobSubType, setValueJobSubType] = useState(null);
  const [valueAssignedGroup, setAssignedGroup] = useState(null);
  const [disableSubmit, setDisableSubmit] = useState(false);
  // console.log('JobTypeId',JobTypeId)
  /* callapi */
  useEffect(() => {
    async function fetchData() {
      ServiceApi.get("JobItsm/GetOpenJobDetail/" + job_id)
        .then((res) => {
          const data = res.data.data;
          setDataLoad(data);
          ServiceApi.post("getButtonDetailWeb", {
            ActionID: 1,
            CompanyID: CompanyId,
            JobTypeID:
              data.job_type_id === null ? valueJobType : data.job_type_id,
            MainProcessID: "0",
            SubProcessID: "-1",
            ProjectID: ProjectId,
            UserName: Cookies.get("username"),
            Version: 1,
            WF_ID: 0,
            operator_id: OperatorId,
          })
            .then((res) => {
              setValueTextFilter(data.job_site_code);
              setworkflowJob(res.data.return_nextWorkFlow);
              setCheckReopen(data.IsReopen);
              setWorkCenterID(data.work_center_id);
              // const workflow = res.data.return_nextWorkFlow;
              // function checkcanEdit() {
              //   let canEdit = false;
              //   if (workflow && workflow.length > 0) {
              //     workflow.map((data) => {
              //       if (data.next_main_action_id === 25) {
              //         canEdit = true;
              //       }
              //     });
              //   }
              //   return canEdit;
              // }
              // if (!checkcanEdit()) {
              //   // window.location.assign("/MaxiOperation/ma_list");
              // }
            })
            .catch((e) => {
              console.log(e);
            });

          // problem_detail
          // inform_remark
          setFormData({
            job_cat_id: data.job_category_id,
            job_no: data.job_no,
            job_id: data.job_id,
            job_type_id: data.job_type_id,
            saptype: data.sap_type_id,
            workcenter: data.work_center_id,
            alarmtype: data.alarm_type_id,
            slalevel: data.job_sla_id,
            priority: data.priority_id,
            employment: data.employment_flag,
            employmenttype: data.employment_type_flag,
            employmentreson: data.employment_remark,
            numofeffectsite: data.site_effect_Number,
            effectsiteid: data.site_code_list,
            IsHold: data.IsHold,
          });

          // ServiceApi.post("job_detail/get_job_fulldetail", {
          //   company_id: CompanyId,
          //   operator_id: OperatorId,
          //   project_id: ProjectId,
          //   job_id: job_id,
          //   job_progress_id: data.job_progress_id,
          // }).then((res) => {
          //   const SiteData = res.data.data.result_site_detail;
          //   const DetailData = data;
          //   SiteData.map((data) => {
          //     if (data.job_site_typeId === 1) {
          //       setFormData((FormData) => ({
          //         ...FormData,
          //         startjob_site_id: data.job_site_id,
          //         startsiteid: data.job_site_code,
          //         startsitegrade: data.job_site_grade,
          //         startsitename: data.job_site_name,
          //         startsitelatitude: Number(data.location_lat),
          //         startsitelongtitude: Number(data.location_lon),
          //       }));
          //     } else {
          //       setFormData((FormData) => ({
          //         ...FormData,
          //         stopjob_site_id: data.job_site_id,
          //         stopsiteid: data.job_site_code,
          //         stopsitegrade: data.job_site_grade,
          //         stopsitename: data.job_site_name,
          //         stoptsitelatitude: Number(data.location_lat) || 0,
          //         stoptsitelongtitude: Number(data.location_lon) || 0,
          //       }));
          //     }
          //   });
          //   console.log(DetailData);
          setFormData((Form) => ({
            ...Form,
            jobdetail: data.problem_detail,
            sla_time_day: data.total_days,
            sla_time_hour: data.total_hour,
            sla_time_min: data.total_min,
            job_sub_type_id: data.job_sub_type_id,
            soid: data.so_id,
            sap_id: data.sap_id,
            subcenter: data.sub_center_code,
            alarm_data: data.alarm_data,
            startdate: data.first_start_date,
            remark: data.inform_remark,
            madate: data.emp_inform_date,
            informby: data.emp_name,
            employmentreson: data.employment_remark,
          }));
          setSlatime({
            sla_time_day: data.total_days || `-`,
            sla_time_hour: data.total_hour || `-`,
            sla_time_min: data.total_min || `-`,
          });
          // });
        })
        .catch((e) => {
          console.log(e);
        });
      setTimeout(() => {
        setSpinnig(false);
      }, 3000);
    }
    fetchData();
  }, [job_id]);
  /* function */
  function changeValue(e) {
    const { name, value } = e.target;
    setFormData((FormData) => ({
      ...FormData,
      [name]: value,
    }));
  }
  function handleSelectValue(type, value, key) {
    if (type === "slalevel") {
      let indexSelected = Number(key.key);
      let selectvalue = Number(key.value);
      setFormData((FormData) => ({
        ...FormData,
        [type]: selectvalue,
      }));
      setSlatime({
        sla_time_day: Sla[indexSelected].sla_time_day || 0,
        sla_time_hour: Sla[indexSelected].sla_time_hour || 0,
        sla_time_min: Sla[indexSelected].sla_time_min || 0,
      });
      setFormData((FormData) => ({
        ...FormData,
        sla_time_day: Sla[indexSelected].sla_time_day || 0,
        sla_time_hour: Sla[indexSelected].sla_time_hour || 0,
        sla_time_min: Sla[indexSelected].sla_time_min || 0,
      }));
    } else if (type === "workcenter") {
      let areaCodeM = String(key.key.split("_")[4]);
      setFormData((FormData) => ({
        ...FormData,
        [type]: value,
      }));
      setareacode(areaCodeM);
    } else {
      setFormData((FormData) => ({
        ...FormData,
        [type]: value,
      }));
    }
  }
  function handleDatePicker(value, dateString) {
    setFormData((FormData) => ({
      ...FormData,
      startdate: dateString,
    }));
  }
  function onNumValueChange(value) {
    setFormData((FormData) => ({
      ...FormData,
      numofeffectsite: value,
    }));
  }
  let setData = null;
  const onSubmit = async () => {
    const IsCheckSubmit = await ServiceApi.get(
      "JobItsm/GetOpenJobDetail/" + job_id
    );
    if (IsCheckSubmit.data?.data?.IsOpen || IsCheckSubmit.data.data === null) {
      errorResultNotify("Please Check Job In Process Create !!!");
      setTimeout(() => {
        window.location.assign("/MaxiOperation/newjob");
      }, 800);
    } else {
      let CanSave = true;
      setsubmitStatus(true);
      for (let x in FormData) {
        if (FormData[x] === "" && CanSave) {
          CanSave = false;
        }
      }
      console.log(JobCategory);
      console.log(JobTypeId);
      console.log(FormData.job_sub_type_id);
      console.log(FormData.startdate);
      console.log(FormData.workcenter);
      console.log(FormData.slalevel);
      if (FormData["workcenter"] === null) {
        FormData["workcenter"] = workCenterID;
      }
      if (
        JobCategory !== null &&
        JobCategory !== "" &&
        JobTypeId !== null &&
        JobTypeId !== "" &&
        FormData.job_sub_type_id !== "" &&
        FormData.job_sub_type_id !== null &&
        FormData.startdate !== "" &&
        FormData.startdate !== null &&
        FormData.workcenter !== "" &&
        FormData.workcenter !== null &&
        FormData.slalevel
      ) {
        ServiceApi.post("getButtonDetailWeb", {
          WF_ID: 0,
          CompanyID: Cookies.get("companyid"),
          ProjectID: ProjectId,
          JobTypeID: JobTypeId,
          Version: 1,
          MainProcessID: "0",
          SubProcessID: "-1",
          ActionID: 1,
          UserName: Cookies.get("username"),
          operator_id: Cookies.get("operator_id"),
        }).then((res) => {
          if (res.data.return_nextWorkFlow[0]) {
            setData = {
              wfData: [
                {
                  ...res.data.return_nextWorkFlow[0],
                },
              ],
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: ProjectId,
              job_category_id: JobCategory,
              job_type_id: JobTypeId,
              job_no: "",
              first_start_date: FormData.startdate,
              inform_name: FormData.informby,
              jobSiteList: [
                {
                  job_site_id: 0,
                  job_site_typeId: 1,
                  job_site_code: FormData.startsiteid,
                  job_site_grade: FormData.startsitegrade,
                  job_site_name: FormData.startsitename,
                  location_lat: FormData.startsitelatitude,
                  location_lon: FormData.startsitelongtitude,
                },
                {
                  job_site_id: 0,
                  job_site_typeId: 2,
                  job_site_code: FormData.stopsiteid,
                  job_site_grade: FormData.stopsitegrade,
                  job_site_name: FormData.stopsitename,
                  location_lat: FormData.stoptsitelatitude,
                  location_lon: FormData.stoptsitelongtitude,
                },
              ],
              job_sub_type_id: FormData.job_sub_type_id,
              multiple_asset_flag: "0",
              asset_id: "0",
              asset_code: "0",
              area_id: "0",
              sub_area_id: "0",
              location_lat: "0",
              location_lon: "0",
              location_name: "",
              emp_inform_id: Cookies.get("userId"),
              inform_detail: " ",
              inform_remark: FormData.remark,
              priority_level: "0",
              is_active: "1",
              job_status: "0",
              last_job_progress_id: "0",
              last_assign_date: "",
              last_assign_type: "",
              last_person_id: "",
              last_job_remark: "",
              create_method: "",
              create_date: "",
              update_date: "",
              update_by: "",
              delete_date: "",
              delete_by: "",
              trans_flag: "",
              total_assign: "",
              total_amount: "",
              total_vat: "",
              total_amount_bf_vat: "0",
              finish_date: "",
              approved_status: "0",
              approved_by: "",
              approved_remark: "",
              use_material: "",
              sla_pass: "",
              picture_location: "",
              picture_path: "",
              ma_period_id: "",
              service_type_level_id: "0",
              job_point: "0",
              form_id: "0",
              data_dynamic: "",
              interface_id: "0",
              interface_sub_id: "0",
              interface_type: "0",
              interface_attrib1: "0",
              interface_attrib2: "0",
              interface_attrib3: "0",
              priority_id: FormData.priority,
              alarm_data: FormData.alarmdata,
              alarm_type_id: FormData.alarmtype,
              create_by: Cookies.get("username"),
              emp_ma_date: FormData.startdate,
              employment_flag: FormData.employment,
              employment_remark: FormData.employmentreson,
              employment_type_flag: FormData.employmenttype,
              problem_detail: FormData.jobdetail,
              result_detail: "",
              site_code_list: FormData.effectsiteid,
              site_effect_Number: FormData.numofeffectsite,
              job_sla_id: FormData.slalevel,
              sla_level_id: "0",
              so_id: FormData.soid,
              sub_center_code: FormData.subcenter,
              total_days: FormData.sla_time_day,
              total_hour: FormData.sla_time_hour,
              total_min: FormData.sla_time_min,
              work_center_id:
                FormData.workcenter === null
                  ? workCenterID
                  : FormData.workcenter,
              sap_type_id: FormData.saptype,
            };
          } else {
            errorNotificationCannot();
            setsubmitStatus(false);
          }
          console.log("setData>>>>>>>", setData);
          if (setData.wfData[0].wf_id === null) {
            errorNotificationCannot();
            setsubmitStatus(false);
          } else {
            ServiceApi.post("job_detail/insert_oper_job_trs", setData)
              .then(async (res) => {
                if (res.data.result.code === "P") {
                  setData = null;
                  const AckJobItsm = await ServiceApi.post(
                    "JobItsm/AckJobItsm",
                    {
                      so_id: FormData.soid,
                      Assignee: Cookies.get("userITSM"),
                      job_category_id: 1,
                      IsOriginalStation: true,
                    }
                  );
                  const ApproveJobItsm = await ServiceApi.post(
                    "JobItsm/ApproveJobItsm",
                    {
                      job_id: job_id,
                      company_id: CompanyId,
                      operator_id: OperatorId,
                      project_id: ProjectId,
                      IsApprove: true, // reject = false
                    }
                  );

                  if (
                    AckJobItsm.data.result.code === "P" &&
                    ApproveJobItsm.data.result.code === "P"
                  ) {
                    SuccessNotification(AckJobItsm.data.result.description);
                    SuccessNotification(ApproveJobItsm.data.result.description);
                    setTimeout(() => {
                      window.location.assign("/MaxiOperation/ma_list"); // unremark this
                      //window.location.assign("/MaxiOperation/addjob");
                      setsubmitStatus(false);
                    }, 1000);
                  } else {
                    errorResultNotify(res.data.result?.showText);
                    setsubmitStatus(false);
                  }
                } else if (res.data.result.code === "F") {
                  errorResultNotify(res.data.result?.showText);
                  setsubmitStatus(false);
                }
              })
              .catch((e) => {
                console.log(e);
                setsubmitStatus(false);
              });
          }
        });
      } else {
        var checkText = "";
        checkText +=
          JobCategory === null || JobCategory === "" ? "Job Catrgory ," : "";
        checkText += JobTypeId === null || JobTypeId === "" ? "Job Type ," : "";
        checkText +=
          FormData.job_sub_type_id === null || FormData.job_sub_type_id === ""
            ? "Job Sub Type ,"
            : "";
        checkText +=
          FormData.startdate === null || FormData.startdate === ""
            ? "Start Date ,"
            : "";
        checkText +=
          FormData.workcenter === null || FormData.workcenter === ""
            ? "Work Center ,"
            : "";
        checkText +=
          FormData.slalevel === null || FormData.slalevel === ""
            ? "Sla Level ,"
            : "";
        errorNotification(checkText);
        setsubmitStatus(false);
      }
    }
  };
  function errorNotification(Text) {
    const args = {
      message: "ผิดพลาด",
      description: "กรุณาเลือก " + Text,
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }
  function errorNotificationCannot() {
    const args = {
      message: "ผิดพลาด",
      description: "คุณไม่มีสิทธ์ในการใช้งาน",
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }
  function SuccessNotification(msg) {
    const args = {
      message: "สำเร็จ",
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification.success(args);
  }
  function errorResultNotify(msg) {
    const args = {
      message: "Error",
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }

  async function onReject() {
    const ApproveJobItsm = await ServiceApi.post("JobItsm/ApproveJobItsm", {
      job_id: job_id,
      company_id: dataLoad.company_id,
      operator_id: dataLoad.operator_id,
      project_id: dataLoad.project_id,
      IsApprove: false,
    });
    const RejectJobItsm = await ServiceApi.post("JobItsm/RejectJobItsm", {
      so_id: FormData.soid,
      Assignee: Cookies.get("userITSM"),
      project_id: dataLoad.project_id,
      IsCreateTask: valueRadio,
      job_id: job_id,
      AssignedGroup: valueAssignedGroup,
      job_type_id: valueJobType,
      job_sub_type_id: valueJobSubType,
    });
    if (
      ApproveJobItsm.data.result.code === "P" &&
      RejectJobItsm.data.result.code === "P"
    ) {
      SuccessNotification(ApproveJobItsm.data.result.description);
      setTimeout(() => {
        window.location.assign("/MaxiOperation/ma_list");
        //window.location.assign("/MaxiOperation/addjob");
        setsubmitStatus(false);
      }, 1000);
    } else {
      if (ApproveJobItsm.data.result.code === "f") {
        errorResultNotify(ApproveJobItsm.data.result?.showText);
        setsubmitStatus(false);
      } else {
        errorResultNotify(RejectJobItsm.data.result?.showText);
        setsubmitStatus(false);
      }
    }
  }
  async function onUnhold() {
    setDisableSubmit(true);

    try {
      const resUnhold = await ServiceApi.post("JobItsm/Unhold", {
        incidentId: FormData.soid,
      });

      if (resUnhold.data.result.code === "P") {
        SuccessNotification(resUnhold.data.result.description);
        setTimeout(() => {
          window.location.assign("/MaxiOperation/newjob");
          setsubmitStatus(false);
        }, 1000);
      } else {
        errorResultNotify(resUnhold.data.result?.showText);
        setsubmitStatus(false);
      }
    } catch (error) {
      errorResultNotify(error.message);
    } finally {
      setDisableSubmit(false);
    }
  }
  async function onReopen() {
    const AckJobItsm = await ServiceApi.post("JobItsm/AckJobItsm", {
      so_id: FormData.soid,
      Assignee: Cookies.get("userITSM"),
      job_category_id: 1,
      IsOriginalStation: true,
    });
    const ApproveReopenJobItsm = await ServiceApi.post(
      "JobItsm/ApproveReopenJobItsm",
      {
        so_id: FormData.soid,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        IsApprove: true, // reject = false
      }
    );
    if (
      ApproveReopenJobItsm.data.result.code === "P" &&
      AckJobItsm.data.result.code === "P"
    ) {
      SuccessNotification(AckJobItsm.data.result.description);
      setTimeout(() => {
        window.location.assign("/MaxiOperation/ma_list");
        //window.location.assign("/MaxiOperation/addjob");
        setsubmitStatus(false);
      }, 1000);
    } else {
      errorResultNotify(ApproveReopenJobItsm.data.result?.showText);
      setsubmitStatus(false);
    }
  }
  async function onLoadMasterData() {
    onLoadDataReject();
    onLoadMasterGetAssignedGroup();
  }
  async function onLoadMasterJobType() {
    ServiceApi.post("V4/get_job_type", {
      pk_id: null,
      fk_id: JobCategory,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      UserName: Cookies.get("username"),
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["job_type_id"],
            label: response.data.data[i]["job_type_name"],
          });
        }
        setSelectJobType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  async function onLoadMasterGetAssignedGroup() {
    ServiceApi.get("JobMaxi/GetAssignedGroup/" + dataLoad.project_id)
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["AssignedGroupName"],
            label: response.data.data[i]["AssignedGroupName"],
          });
        }
        setSelectAssignedGroup(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  async function onLoadMasterJobSub(value) {
    setValueJobSubType(null);
    ServiceApi.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: JobCategory,
      job_type_id: value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + CompanyId,
      operator_id: OperatorId,
    })
      .then((response) => {
        var setData = [];
        for (
          let i = 0;
          i < response.data.data.job_sub_type_dto_list.length;
          i++
        ) {
          setData.push({
            value:
              response.data.data.job_sub_type_dto_list[i]["job_sub_type_id"],
            label: response.data.data.job_sub_type_dto_list[i]["job_type_name"],
          });
        }
        setSelectJobSubType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  async function onLoadDataReject() {
    ServiceApi.get("JobMaxi/GetOperTierJobItsm/" + job_id)
      .then((response) => {
        setValueJobType(response.data.data.job_type_id);
        setValueJobSubType(response.data.data.job_sub_type_id);
        onLoadMasterJobType();
        onLoadMasterJobSub(response.data.data.job_type_id);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MaxiOperation - Create Job</title>
      </Helmet>
      <Layout></Layout>
      <Header
        title={`Create Job Maintenance`}
        preventPage={`Ma List`}
        currentPage={`Create Job Maintenance`}
      ></Header>
      <Spin spinning={Spinnig} delay={500}>
        <Mainjobtype></Mainjobtype>

        {!Spinnig ? (
          <>
            {/* <div className="d-flex justify-content-center"> */}
            <div className="row d-flex justify-content-center text-nowarp">
              <Jobdetail
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                title={factUpdate ? LangTranslate[locale]["job_detail"] : null}
                iscopy={false}
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                selectchange={handleSelectValue}
                language={LangTranslate}
                factupdate={factUpdate}
                updatejobcategory={setJobCategory}
                updatejobtype={setJobTypeId}
                selectjobcat={setJobCatSelect}
                jobcatselect={JobCatSelect}
                updatesla={setSla}
                sla={Sla}
                slatime={Slatime}
              ></Jobdetail>
              <Startstation
                title={
                  factUpdate ? LangTranslate[locale]["start_station"] : null
                }
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
                latitude={FormData.startsitelatitude}
                longtitude={FormData.startsitelongtitude}
                areacode={areacode}
                checkPage={true}
                textFilter={valueTextFilter}
              ></Startstation>
            </div>
            <div className="row d-flex justify-content-center text-nowarp">
              <Problemdetail
                title={
                  factUpdate ? LangTranslate[locale]["problem_detail"] : null
                }
                formdata={FormData}
                valuechange={changeValue}
                selectchange={handleSelectValue}
                datepicker={handleDatePicker}
                language={LangTranslate}
                factupdate={factUpdate}
                jobcategory={JobCategory}
                jobtypeid={JobTypeId}
                jobcatselect={JobCatSelect}
                sla={Sla}
                slatime={Slatime}
              ></Problemdetail>
              <Stopstation
                title={
                  factUpdate ? LangTranslate[locale]["stop_station"] : null
                }
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
                latitude={FormData.stoptsitelatitude}
                longtitude={FormData.stoptsitelongtitude}
                areacode={areacode}
              ></Stopstation>
            </div>
            <div className="row d-flex justify-content-center text-nowarp">
              <Employment
                title={factUpdate ? LangTranslate[locale]["employment"] : null}
                formdata={FormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
              ></Employment>
              <Effectsite
                title={
                  factUpdate ? LangTranslate[locale]["effected_site"] : null
                }
                formdata={FormData}
                valuechange={changeValue}
                numberchange={onNumValueChange}
                language={LangTranslate}
                factupdate={factUpdate}
              ></Effectsite>
            </div>
            <div className="row d-flex justify-content-center pb-5 mt-5 text-nowarp">
              {submitStatus ? (
                <button type="button" disabled className="btnbrows">
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
              ) : dataLoad?.IsHold ? (
                <Spin
                  indicator={<LoadingOutlined spin />}
                  spinning={disableSubmit}
                  size="small"
                >
                  <button
                    disabled={disableSubmit}
                    type="button"
                    className="btnbrows"
                    onClick={onUnhold}
                  >
                    <span className="font-thai-b fs-22">{`Unhold`}</span>
                  </button>
                </Spin>
              ) : (
                <>
                  <button
                    type="button"
                    className="btnbrows"
                    onClick={checkReopen ? onReopen : onSubmit}
                  >
                    <span className="font-thai-b fs-22">
                      {factUpdate ? LangTranslate[locale]["submit"] : `Submit`}
                    </span>
                  </button>
                  <button
                    type="button"
                    className="btnbrows ml-3"
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      borderColor: "#dc3545",
                    }}
                    onClick={() => {
                      setVisibleModal(true);
                      onLoadMasterData();
                    }}
                  >
                    <span className="font-thai-b fs-22">{"Reject"}</span>
                  </button>
                </>
              )}
            </div>
          </>
        ) : null}

        <Modal
          title="Reject"
          visible={visibleModal}
          footer={false}
          onCancel={() => setVisibleModal(false)}
        >
          <div className="row">
            <div className="col-6">
              <span className="float-left mb-2">{"Job Type"}</span>
              <br />
              <Select
                size={"middle"}
                placeholder="Please select"
                value={valueJobType}
                onChange={(e) => {
                  onLoadMasterJobSub(e);
                  setValueJobType(e);
                }}
                style={{
                  width: "100%",
                }}
                options={selectJobType}
              />
            </div>
            <div className="col-6">
              <span className="float-left mb-2">{"Job Sub Type"}</span>
              <br />
              <Select
                size={"middle"}
                value={valueJobSubType}
                placeholder="Please select"
                onChange={(e) => setValueJobSubType(e)}
                style={{
                  width: "100%",
                }}
                options={selectJobSubType}
              />
            </div>
            <div className="col-12 mt-2 mb-2">
              <span className="float-left mb-2">{"Assigned Group Name"}</span>
              <br />
              <Select
                size={"middle"}
                value={valueAssignedGroup}
                placeholder="Please select"
                onChange={(e) => setAssignedGroup(e)}
                style={{
                  width: "100%",
                }}
                options={selectAssignedGroup}
              />
            </div>
            <div className="col-12">
              <br />
              <Radio.Group
                name="radiogroup"
                defaultValue={valueRadio}
                onChange={(e) => setValueRadio(e.target.value)}
              >
                <Radio value={true}>สร้าง Task ITSM</Radio>
                <Radio value={false}>ไม่สร้าง Task ITSM</Radio>
              </Radio.Group>
            </div>
            <div className="col-12 mt-3" style={{ textAlign: "right" }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setVisibleModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                onClick={() => onReject()}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
  LangTranslate: state.masterLang.masterLang,
  factUpdate: state.masterLang.factUpdate,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Editjob);
